import * as React from "react";

function SvgLantern(props, ref) {
  return (
    <svg
      id="Lantern_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 67.8 107.8"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Lantern_svg__st0{fill:#ec758c}.Lantern_svg__st1{fill:#88d1e0}.Lantern_svg__st2{fill:#70aeb7}.Lantern_svg__st3{fill:#d74e70}"
        }
      </style>
      <g id="Lantern_svg__Group_5" transform="translate(-331.746 -246.124)">
        <path
          id="Lantern_svg__Path_12"
          className="Lantern_svg__st0"
          d="M374.4 327c2.1-.7 4-1.6 5.9-2.8l-14.6-25.3-14.7 25.3c1.8 1.2 3.8 2.1 5.9 2.8l8.7-15.1 8.8 15.1z"
        />
        <path
          id="Lantern_svg__Path_13"
          className="Lantern_svg__st1"
          d="M372.9 274.7V268c-4.8-1.1-9.8-1.1-14.6 0v6.7c4.8-1.4 9.9-1.4 14.6 0z"
        />
        <path
          id="Lantern_svg__Path_14"
          className="Lantern_svg__st1"
          d="M338.2 301.1c0-9.7 5.2-18.7 13.6-23.6v-7.3c-17.1 7.6-24.8 27.5-17.2 44.6 2.8 6.2 7.3 11.5 13.1 15.1l3.2-5.6c-7.8-5.1-12.6-13.9-12.7-23.2z"
        />
        <path
          id="Lantern_svg__Path_15"
          className="Lantern_svg__st0"
          d="M356.9 327c-2.1-.7-4-1.6-5.9-2.8l-3.2 5.6c1.8 1.1 3.8 2.1 5.8 2.9l3.3-5.7z"
        />
        <path
          id="Lantern_svg__Path_16"
          className="Lantern_svg__st1"
          d="M374.4 327l3.3 5.7c2-.8 4-1.7 5.8-2.9l-3.2-5.6c-1.9 1.2-3.9 2.1-5.9 2.8z"
        />
        <path
          id="Lantern_svg__Path_17"
          className="Lantern_svg__st0"
          d="M358.4 252.6H373V268c2.2.5 4.4 1.2 6.5 2.1v-24H352v24c2.1-.9 4.3-1.7 6.5-2.1v-15.4z"
        />
        <path
          id="Lantern_svg__Path_18"
          className="Lantern_svg__st0"
          d="M372.9 274.7c2.3.6 4.5 1.5 6.5 2.7v-7.3c-2.1-.9-4.3-1.7-6.5-2.1v6.7z"
        />
        <path
          id="Lantern_svg__Path_19"
          className="Lantern_svg__st1"
          d="M358.4 274.7V268c-2.2.5-4.4 1.2-6.5 2.1v7.3c2-1.2 4.2-2.1 6.5-2.7z"
        />
        <path
          id="Lantern_svg__Path_20"
          className="Lantern_svg__st1"
          d="M377.7 332.7l-3.3-5.7c-2.8 1-5.8 1.4-8.7 1.5-1.1 0-2.1-.1-3.2-.2l-3.5 6c2.2.5 4.4.7 6.7.7 4-.1 8.1-.8 12-2.3z"
        />
        <path
          id="Lantern_svg__Path_21"
          className="Lantern_svg__st2"
          d="M361.3 328.1c-1.5-.2-2.9-.6-4.4-1.1l-3.3 5.7c1.4.5 2.8.9 4.3 1.3.4.1.7.2 1.1.2l3.5-6c-.4 0-.8-.1-1.2-.1z"
        />
        <path
          id="Lantern_svg__Path_22"
          className="Lantern_svg__st0"
          d="M386.2 334.5c-1.9 1.1-3.8 2.1-5.8 2.9l5.8 10h-41l8.5-14.7c-2-.8-4-1.7-5.8-2.9L334 353.9h63.5l-11.3-19.4z"
        />
        <path
          id="Lantern_svg__Path_23"
          className="Lantern_svg__st3"
          d="M383.5 329.8c-1.8 1.1-3.8 2.1-5.8 2.9l2.7 4.7c2-.8 4-1.8 5.8-2.9l-2.7-4.7z"
        />
        <path
          id="Lantern_svg__Path_24"
          className="Lantern_svg__st1"
          d="M384.8 273.2v8.4c10.8 10.5 11 27.8.4 38.6-1.5 1.5-3.2 2.9-5 4l3.2 5.6c15.9-9.8 20.8-30.6 11-46.5-2.4-4-5.7-7.4-9.6-10.1z"
        />
        <path
          id="Lantern_svg__Path_25"
          className="Lantern_svg__st0"
          d="M372.9 280.4v5.3h-14.6v-5.3c-1.3.4-2.6 1-3.8 1.7l-2.7 1.6v8.5h27.5v-8.5l-2.7-1.6c-1.1-.7-2.4-1.3-3.7-1.7z"
        />
        <path
          id="Lantern_svg__Path_26"
          className="Lantern_svg__st2"
          d="M379.4 270.1v7.3c2 1.2 3.8 2.5 5.4 4.1v-8.4c-1.7-1.1-3.5-2.1-5.4-3z"
        />
        <path
          id="Lantern_svg__Path_27"
          className="Lantern_svg__st0"
          d="M372.9 274.7v5.7c1.3.4 2.6 1 3.8 1.7l2.7 1.6v-6.3c-2-1.2-4.2-2.1-6.5-2.7z"
        />
        <path
          id="Lantern_svg__Path_28"
          className="Lantern_svg__st3"
          d="M358.4 280.4v-5.7c-2.3.6-4.5 1.5-6.5 2.7v6.3l2.7-1.6c1.2-.7 2.5-1.3 3.8-1.7z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgLantern);
